<template>
  <div v-if="getResolving || getRedirecting" class="auth-splash">
    <span class="auth-splash__spinner" aria-label="Carregando" />
  </div>
  <router-view v-else />
  <g-dialog-root />
</template>

<script>
import { GDialogRoot } from 'gitart-vue-dialog'
import { mapActions, mapGetters } from 'vuex'

export default {
  components: {
    GDialogRoot,
  },
  computed: {
    ...mapGetters({
      getClientSizeW: 'screen/getClientSizeW',
      getScrollState: 'screen/getScrollState',
      getResolving: 'session/getResolving',
      getRedirecting: 'session/getRedirecting',
    }),
  },
  mounted() {
    window.addEventListener('scroll', this.handleScroll)
    window.addEventListener('resize', this.handleResize)
    window.addEventListener('pageshow', this.handlePageShow)
    this.handleResize()
  },
  unmounted() {
    window.removeEventListener('scroll', this.handleScroll)
    window.removeEventListener('resize', this.handleResize)
    window.removeEventListener('pageshow', this.handlePageShow)
  },

  async created() {
    await this.$store.dispatch('session/recoverSession', '')
    await this.$store.dispatch('session/fetchSysHref', '')
  },

  methods: {
    ...mapActions({
      setPos: 'screen/setPos',
      setScrollState: 'screen/setScrollState',
      setClientSize: 'screen/setClientSize',
      setMiniModeState: 'screen/setMiniModeState',
    }),
    handlePageShow(e) {
      if (e.persisted) {
        this.$store.dispatch('session/recoverSession', '')
      }
    },
    handleScroll(e) {
      let pos = Math.max(
        window.pageYOffset,
        document.documentElement.scrollTop,
        document.body.scrollTop
      )

      this.setPos(pos)
      this.setScrollState(pos > 45)
      this.setMiniModeState(this.getClientSizeW < 992)
    },
    handleResize() {
      this.setClientSize({
        width: document.documentElement.clientWidth,
        height: document.documentElement.clientHeight,
      })
    },
  },
}
</script>

<style scoped>
.auth-splash {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 2000;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #ffffff;
}
.auth-splash__spinner {
  width: 48px;
  height: 48px;
  border: 4px solid #e6e6e6;
  border-top-color: #c8102e;
  border-radius: 50%;
  animation: auth-splash-spin 0.8s linear infinite;
}
@keyframes auth-splash-spin {
  to {
    transform: rotate(360deg);
  }
}
</style>
